var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.listData && _vm.listData.length
    ? _c("div", { staticClass: "theater" }, [
        _c("h3", [_vm._v("剧场版")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.listData, function (item, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                {
                  attrs: {
                    href: item.url,
                    uigs: "tiny_out_theater_" + index + "_p",
                    title: item.name,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "dt-theater-img" },
                    [
                      _c("Image-1", { attrs: { src: item.picurl } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tag-mark" }, [
                        _vm._v(
                          _vm._s(
                            item.score && item.score.length === 1
                              ? item.score + ".0"
                              : item.score
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "theater-name" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                ]
              ),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }